/***********************
 * DEFAULT SORT
 ***********************/
function setDefaultSort() {
  const sortElement = document.getElementById('junipReviewSort');
  if (!sortElement) return false;

  // Keep only valid options
  [...sortElement.options].forEach(opt => {
    if (!["mostHelpful", "mostRecent"].includes(opt.value)) opt.remove();
  });

  return true;
}

/***********************
 * Initialize
 ***********************/
document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver(() => {
    const toggle = document.querySelector(".junip-filters-toggle");
    const sort = document.getElementById("junipReviewSort");
  
    if (toggle && !toggle.dataset.clicked) {
      toggle.dataset.clicked = "true";
      toggle.click();
      return; 
    }
  
    if (sort && setDefaultSort()) {
      observer.disconnect();
    }
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
});

